<h2 mat-dialog-title> Modificar mantenimiento</h2>
<mat-dialog-content>

  <mat-tab-group animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">info</mat-icon>Información</ng-template>
      <mat-card class="cardInfo">
        @if (showProgressBar) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <form [formGroup]="form">
          <mat-form-field class='formField' matTooltip="No puedes modificar el contenedor">
            <mat-label>Contenedor</mat-label>
            <mat-select formControlName="contenedor" [(value)]="contenedor" required disabled>
              <input placeholder="Buscar..." (keyup)="filterSelect_Contenedores($event.target.value)" class="inputSelectSearch">
              @for (contenedor of contenedores; track contenedor) {
                <mat-option [value]="contenedor.id">{{contenedor.matricula}}</mat-option>
              }
            </mat-select>
            <mat-error>Debes seleccionar un contenedor.</mat-error>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Estado</mat-label>
            <mat-select formControlName="estado" [(value)]="estado" required>
              <mat-option value="pending">Pendiente inicio</mat-option>
              <mat-option value="process">En proceso</mat-option>
              <mat-option value="finish">Finalizado</mat-option>
            </mat-select>
            <mat-error>Debes seleccionar un estado.</mat-error>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="tipo" required>
              <mat-option value="paint">Pintado</mat-option>
              <mat-option value="fix">Reparación</mat-option>
              <mat-option value="incidence">Incidencia</mat-option>
            </mat-select>
            <mat-error>Debes seleccionar un tipo.</mat-error>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Fecha de alta</mat-label>
            <div (click)="fechaAltaPicker.open()">
              <input matInput [matDatepicker]="fechaAltaPicker" (dateChange)="dateChangeAlta($event)" formControlName="fechaAlta" disabled placeholder="Fecha de alta" required>
            </div>
            <mat-datepicker-toggle matSuffix [for]="fechaAltaPicker" color="primary"></mat-datepicker-toggle>
            <mat-datepicker touchUi #fechaAltaPicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Fecha última acción</mat-label>
            <div (click)="fechaAccionPicker.open()">
              <input matInput [matDatepicker]="fechaAccionPicker" (dateChange)="dateChangeAccion($event)" formControlName="fechaAccion" disabled placeholder="Fecha última acción" required>
            </div>
            <mat-datepicker-toggle matSuffix [for]="fechaAccionPicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #fechaAccionPicker disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Coste</mat-label>
            <input matInput placeholder="Coste" formControlName="coste" [(value)]="coste">
            <mat-error>El coste no es valido.</mat-error>
          </mat-form-field>
          <mat-form-field class='formField'>
            <mat-label>Observaciones</mat-label>
            <input matInput placeholder="Observaciones" formControlName="observaciones" [(value)]="observaciones">
          </mat-form-field>
        </form>
      </mat-card>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><mat-icon class="tab-icon" color="primary">photo_library</mat-icon>Galería</ng-template>
      <app-gallery [id]="mantenimiento" [tipo]="'mantenimiento'"></app-gallery>
    </mat-tab>
  </mat-tab-group>

  <!-- FORM VALIDATORS VIEWERS
  {{form.get('contenedor').errors | json}}
  {{form.get('tipo').errors | json}}
  {{form.get('coste').errors | json}}
  {{form.get('observaciones').errors | json}}
  {{form.get('estado').errors | json}}
  {{form.get('fechaAlta').errors | json}}
  {{form.get('fechaAccion').errors | json}}-->

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-raised-button (click)="save()" color="primary">Guardar</button>
</mat-dialog-actions>
